import { Box } from '@ouster/webviz-react-components';

import { Chip } from '@mui/material';

import userLookupStyle from './userLookup.module.css';

interface InfoItemProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  value: string | number;
  color?: 'default' | 'error' | 'info' | 'success' | 'warning';
}

export default function InfoItem({
  label,
  value,
  color,
  ...rest
}: InfoItemProps) {
  return (
    <Box data-testid="info-item" {...rest}>
      <Box className={userLookupStyle.infoTitle} data-testid="info-item-label">
        {label}
      </Box>
      <Box
        className={`${userLookupStyle.infoContent}`}
        data-testid="info-item-value"
      >
        {color ? (
          <Chip
            color={color}
            label={value}
            size="small"
            sx={{
              textTransform: 'uppercase',
            }}
          />
        ) : (
          value
        )}
      </Box>
    </Box>
  );
}
